import { transChoice } from '@lingoda/i18n';
import { ClockIcon, UsersThreeIcon } from '@lingoda/ui/icons/lingodaIcons';
import { Stack, Typography } from '@lingoda/ui';

interface Props {
    statusText: string;
    participants: number;
}

export const ChallengeParticipationStatus = ({ statusText, participants }: Props) => {
    return (
        <Stack
            spacing={2}
            paddingY={2}
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'center', sm: 'normal' }}
        >
            <Stack spacing={1} direction="row">
                <ClockIcon size={24} />
                <Typography variant="body1">{statusText}</Typography>
            </Stack>
            <Stack spacing={1} direction="row">
                <UsersThreeIcon size={24} />
                <Typography variant="body1">
                    {transChoice(
                        'participants',
                        participants,
                        { participants },
                        'student-challenges',
                    )}
                </Typography>
            </Stack>
        </Stack>
    );
};
